module.exports = __webpack_public_path__ + "img/team-2.dcfcf3b7.jpg";